module.exports = __webpack_public_path__ + "static/media/cartempty.b8cc3851.png";